import { extractSectionId } from "theme";
import { MediaGridGHD } from "section-media-grid-ghd";

var ZoomGHD = class extends MediaGridGHD {
	constructor() {
		super();
	}
	
	connectedCallback() {
		if (!this.animatedElement) {
			throw "ERROR";
		}
		
		if (Shopify.designMode) {
			document.addEventListener("shopify:section:load", () => this._initialise());
			document.addEventListener("shopify:section:unload", () => this._initialise());
			document.addEventListener("shopify:section:reorder", () => this._initialise());
		}
		
		this.onResizeHandler = this._initialise.bind(this);
 		window.addEventListener('resize', this.onResizeHandler, false);
	}
	
    disconnectedCallback() {
		window.removeEventListener('resize', this.onResizeHandler);
    }
  
	_initialise(event) {
		if (this.scrollTriggerTimeline) {
			this.scrollTriggerTimeline.kill();
		}
		
		if (ScrollTrigger.getById(this.id)) {
			ScrollTrigger.getById(this.id).kill(true);
		}
		
		this.animatedElement.style.removeProperty('width');
		this.animatedElement.style.removeProperty('height');
		this.animatedElement.style.removeProperty('left');
		this.animatedElement.style.removeProperty('top');
		
		if (this.animatedElement.querySelector('.frame-styling')) {
			this.animatedElement.querySelector('.frame-styling').style.removeProperty('border-radius');
		}
				
		this._createAnimations();
		
		if (event) {
		    this.dispatchEvent(new CustomEvent("scroll:trigger:refresh", { 
				bubbles: true,
				detail: { 
					originalEvent: event
				} 
			}));
		}
	}
  
	_createAnimations() {
		this.scrollTriggerTimeline = gsap.timeline().pause();
		
		const _this = this;
		let animationDuration = 100,
			boundingBox = this.animatedElement.getBoundingClientRect(),
			offsetTop = this.animatedElement.offsetTop,
			animatedElement = this.animatedElement,
			animationTo,
			animationFrom,
			animatedElementChild = animatedElement.querySelector('.frame-styling'),
			animationChildTo,
			animationChildFrom;
	
		if (this.zoomDirection == 'zoom-in') {
			animationFrom = {
				width: boundingBox.width,
				height: boundingBox.height
			}
		
			animationTo = {
				width: window.innerWidth,
				height: window.innerHeight,
				ease: "none"
			}
		} else {
			animationFrom = {
				top: (offsetTop / boundingBox.height) * -100 + '%',
				left: (boundingBox.x / boundingBox.width) * -100 + '%',
				width: (window.innerWidth / boundingBox.width) * 100 + '%',
				height: (window.innerHeight / boundingBox.height) * 100 + '%'
			}
					
			animationTo = {
				top: '0%',
				left: '0%',
				width: '100%',
				height: '100%',
				ease: "none"
			}
		}
		
		gsap.set(
			animatedElement, 
			animationFrom
		);
		
		this.scrollTriggerTimeline.fromTo(
			animatedElement, 
			animationFrom,
			animationTo
		)
		
		if (animatedElement.querySelectorAll('.prose').length) {
			gsap.set(
				animatedElement.querySelectorAll('.prose'), 
				{
					autoAlpha: 0
				}
			);
			this.scrollTriggerTimeline.fromTo(
				animatedElement.querySelectorAll('.prose'), 
				{
					autoAlpha: 0
				},
				{
					autoAlpha: 1,
					duration: 0.1,
					ease: "none"
				},
				'>-0.1'
			)
		}
		
		if (this.animatedElement.querySelector('.frame-styling')) {
			const computedStyles = getComputedStyle(animatedElementChild);
			
			animationChildFrom = {
				borderRadius: this.zoomDirection == 'zoom-in' ? computedStyles.getPropertyValue("border-radius") : 0,
			}
			
			animationChildTo = {
				borderRadius: this.zoomDirection == 'zoom-in' ? 0 : computedStyles.getPropertyValue("border-radius"),
				duration: 0.25
			}
			
			gsap.set(
				animatedElementChild, 
				animationChildFrom
			);
			
			this.scrollTriggerTimeline.fromTo(
				animatedElementChild, 
				animationChildFrom,
				animationChildTo,
				'0.25'
			)
		}
	
		this.scrollTriggerConfig = {
			trigger: this.section,
			animation: this.scrollTriggerTimeline,
			start: this.zoomDirection == 'zoom-in' && this.querySelectorAll('.media-grid__item').length == 1 ? "top bottom" : "top top",
			end: "+=" + animationDuration + "%",
			scrub: true,
			id: this.id
		}
	}
  
	get animatedElement() {
		return this.querySelector('.media-grid__item-zoom');
	}
	
	get zoomDirection() {
		return this.getAttribute('zoom-direction');
	}
	
	get section() {
		const sectionId = extractSectionId(this);
		return document.getElementById('shopify-section-' + sectionId);
	}
};

if (!window.customElements.get("zoom-ghd")) {
	let undefinedCustomElements = [],
		requiredCustomElements = [
			'height-observer'
		],
		customElements = Array.from(document.querySelectorAll(':not(:defined)'));

	customElements.forEach(function(item) {
		if (item.tagName.includes("-") && requiredCustomElements.includes(item.localName)) {
			undefinedCustomElements.push(item);
		}
	});

	let promises = [...undefinedCustomElements].map((item) => {
		return window.customElements.whenDefined(item.localName);
	});

	Promise.all(promises).then(() => {
		window.customElements.define("zoom-ghd", ZoomGHD);
	});
}

export {
	ZoomGHD
};
